module.exports = __webpack_public_path__ + "static/service-section03-img-d80cb7a2e4f883b6c69f35c74ea8888a.png";